import React from 'react'
import moment from 'moment'
import debounce from 'debounce'

import {
    _getSearchEnterprise,
} from '../../services'

import {
    Table,
    Input
} from 'antd'

class EnterpriseTable extends React.Component{

    state = {
        loading: true,
        enterprises: [],
        count: 0,
        page: 1,
        limit: 10,
        searchTerm: ''
    }

    render(){
        return(
            <div>
                <Input
                    style={{width: 400, marginBottom: 24}}
                    placeholder="Search Ref Number"
                    onChange={this.handleSearch}
                />
                {this.renderEnterpriseTable()}
            </div>
        )
    }

    constructor(props){
        super(props)

        this.getEnterprises()

        this.setSearch = debounce(this.setSearch, 400)
    }

    getEnterprises = () => {
        const { page, searchTerm, limit } = this.state

        this.setState({loading: true})

        _getSearchEnterprise({
            searchTerm,
            page,
            limit
        })
        .then( res => {

            const { enterprises, count } = res.data

            this.setState({
                loading: false,
                enterprises,
                count
            })
        })
    }

    setSearch = (searchTerm) => {
        this.setState({
            searchTerm,
            page: 1
        }, this.getEnterprises)
    }

    handleSearch = (e) => {
        this.setSearch(e.target.value)
    }

    renderEnterpriseTable = () => {

        const { page, limit, searchTerm, enterprises, count, loading } = this.state

        const columns = [{
            title: 'Logo',
            dataIndex: 'logoUrl',
            render: (logoUrl) => <img style={{width: 100}} src={logoUrl}/>
        },{
            title: "Enterprise",
            dataIndex: 'companyName'
        },{
            title: 'Action',
            render:(enterprise) => <a
                onClick={()=>this.props.handleSelect(enterprise)}
            >Select</a>
        }]

        return (
            <Table
                loading={loading}
                dataSource={enterprises}
                columns={columns}
                pagination={{
                    pageSize: limit,
                    current: page,
                    total: count
                }}
            />
        )

    }
}

export default EnterpriseTable


// WEBPACK FOOTER //
// ./src/components/credit-payment/enterprise-table.js